import ajax from '../http/ajax'

export const userLogin = data => {
    return ajax.post('login', data)
}

export const userBindingPhone = data => {
    return ajax.post('bindMobile', data)
}

export const getUserInfo = data => {
    return ajax.post('userInfo', data)
}

export const getWxUserInfo = data => {
    return ajax.post('loginWx', data)
}

export const sendBoundMsg = data => {
    return ajax.post('sendBoundMsg', data)
}
